const ONE_WEEK = 604_800_000;

const isMoreThanOneWeekOld = (notif: NotificationFragment) => {
  if (!notif.createTime) {
    return false;
  }
  const oneWeekAgo = new Date(Date.now() - ONE_WEEK);
  const notifDate = new Date(notif.createTime * 1000);
  return notifDate < oneWeekAgo;
};

export default isMoreThanOneWeekOld;
